angular.module('MyHippoProducer.Controllers').directive('optionalDwellingSection', function () {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'pages/policy-details/sections/optional-dwelling/optional-dwelling.html',
    };
});
